import { render, staticRenderFns } from "./PhenotypeTable.vue?vue&type=template&id=3ad25762&scoped=true"
import script from "./PhenotypeTable.vue?vue&type=script&lang=js"
export * from "./PhenotypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad25762",
  null
  
)

export default component.exports